import React from 'react';
import { Text as T } from 'react-konva';
import { COLORS } from 'constants/colors';

// eslint-disable-next-line react/jsx-props-no-spreading
const Text = (props) => <T fill={COLORS.GRAY[400]} scaleX={1} {...props} />;

export default Text;
